export enum DocumentFields {
    deslectedPdf = '0',
    selectedPdf = '1',
    selectedFormat = '10',
    selectedFormatAndPdf = '11'
}
